import React from 'react';
import {
  TextField,
  CircularProgress,
  Button
} from '@mui/material';
import {
  FormPageContainer,
  FormHeader,
  FormSubHeader,
  StyledForm,
  SubmitButton,
  ExecutorSectionHeader,
  ButtonGroupContainer,
  BackButton
} from './ExecutorDetailsForm.styles';

export default function ExecutorDetailsForm({ formData, handleChange, handleSubmit, handleBack, isSubmitting }) {
    return (
        <FormPageContainer>
            <FormHeader variant="h4" component="h1">Will & Testament Creator</FormHeader>
            <FormSubHeader variant="h5" component="h2">Step 3: Executor Details</FormSubHeader>
            <StyledForm component="form" onSubmit={handleSubmit} noValidate>
                <ExecutorSectionHeader variant="h6">First Executor</ExecutorSectionHeader>
                <TextField
                    id="executor1FirstName"
                    name="executor1FirstName"
                    label="First Name(s)"
                    value={formData.executor1FirstName}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ padding: '12px' }}
                />

                <TextField
                    id="executor1LastName"
                    name="executor1LastName"
                    label="Last Name"
                    value={formData.executor1LastName}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ padding: '12px' }}
                />

                <TextField
                    id="executor1IdNumber"
                    name="executor1IdNumber"
                    label="ID Number"
                    value={formData.executor1IdNumber}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ padding: '12px' }}
                />

                <ExecutorSectionHeader variant="h6">Second Executor</ExecutorSectionHeader>
                <TextField
                    id="executor2FirstName"
                    name="executor2FirstName"
                    label="First Name(s)"
                    value={formData.executor2FirstName}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ padding: '12px' }}
                />

                <TextField
                    id="executor2LastName"
                    name="executor2LastName"
                    label="Last Name"
                    value={formData.executor2LastName}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ padding: '12px' }}
                />

                <TextField
                    id="executor2IdNumber"
                    name="executor2IdNumber"
                    label="ID Number"
                    value={formData.executor2IdNumber}
                    onChange={handleChange}
                    required
                    fullWidth
                    sx={{ padding: '12px' }}
                />

                <ButtonGroupContainer>
                    <BackButton 
                        type="button" 
                        variant="contained" 
                        onClick={handleBack}
                        disabled={isSubmitting}
                    >
                        Back
                    </BackButton>
                    <SubmitButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                        startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
                        onClick={(e) => { handleSubmit(e) }}
                    >
                        {isSubmitting ? 'Processing...' : 'Next'}
                    </SubmitButton>
                </ButtonGroupContainer>
            </StyledForm>
        </FormPageContainer>
    );
} 